import React from 'react';

export const SwapActionButton = ({
  isConnected,
  isWalletNetworkAligned,
  requiresApproval = false,
  allowanceEnough = false,
  isLoading = false,
  isDisabled = false,
  buttonText = 'Swap',
  onClick,
}) => {
  const buttonVariantClass = !isConnected
    ? 'connect'
    : !isWalletNetworkAligned
      ? 'approve'
      : !requiresApproval || allowanceEnough
        ? 'swap'
        : 'approve';

  return (
    <button
      className={`swap-button ${buttonVariantClass}`}
      onClick={onClick}
      aria-label={buttonText}
      disabled={isDisabled}
    >
      {isLoading ? 'Processing...' : buttonText}
    </button>
  );
};
